import React from 'react'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  style?: React.CSSProperties
}

export function Skeleton({ width = '100%', height = 14, borderRadius = 6, style }: SkeletonProps) {
  return (
    <div
      className="skeleton"
      aria-hidden="true"
      style={{ width, height, borderRadius, ...style }}
    />
  )
}

export function SkeletonTableRows({ cols, rows = 4 }: { cols: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <tr key={i} aria-hidden="true">
          {Array.from({ length: cols }, (_, j) => (
            <td key={j} style={{ padding: '10px 12px' }}>
              <Skeleton height={13} width={j === 0 ? '70%' : '55%'} />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}

export function SkeletonListItem() {
  return (
    <div aria-hidden="true" style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
        <Skeleton width="45%" height={13} />
        <Skeleton width="18%" height={11} />
      </div>
      <Skeleton width="60%" height={11} style={{ marginBottom: 6 }} />
      <Skeleton width="30%" height={18} borderRadius={99} />
    </div>
  )
}
